import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-proforma',
  templateUrl: './proforma.component.html',
  styleUrls: ['./proforma.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ProformaComponent {
 
}
